const BLOCKED_USER_IDS = ['a753633b-ea6c-4474-957f-c0fde9e7faa9'];

export const shouldIntegrateSessionRecording = (userID: string) => {
  if (BLOCKED_USER_IDS.includes(userID)) {
    return false;
  }

  return process.env.REACT_APP_ENVIRONMENT === 'production';
};
